export default __webpack_public_path__ + "static/media/user.a68a95ea.svg";